import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { formValueSelector } from "redux-form";
import { Translate } from "react-localize-redux";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import styled from "styled-components";

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0.5rem 0 0 0;
`;

const Item = styled.li`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.85rem;
  line-height: 1.6;
  color: ${(props) => (props.$met ? "#2e7d32" : "#6b6b6b")};
`;

function check(password) {
  const v = password || "";
  return {
    length: v.length >= 6,
    uppercase: /[A-Z]/.test(v),
    number: /[0-9]/.test(v),
    special: /[^A-Za-z0-9]/.test(v),
  };
}

const rules = [
  { key: "length", translationId: "register.common.password.rules.length" },
  { key: "uppercase", translationId: "register.common.password.rules.uppercase" },
  { key: "number", translationId: "register.common.password.rules.number" },
  { key: "special", translationId: "register.common.password.rules.special" },
];

function PasswordRequirements({ password }) {
  const state = check(password);
  return (
    <List aria-label="password-requirements">
      {rules.map((r) => {
        const met = state[r.key];
        const Icon = met ? CheckCircleIcon : RadioButtonUncheckedIcon;
        return (
          <Item key={r.key} $met={met}>
            <Icon fontSize="small" />
            <Translate id={r.translationId} />
          </Item>
        );
      })}
    </List>
  );
}

PasswordRequirements.propTypes = {
  password: PropTypes.string,
};

const selector = formValueSelector("form");

export default connect((state) => ({
  password: selector(state, "password"),
}))(PasswordRequirements);
